module.exports = __webpack_public_path__ + "static/media/popup_desktop.bb50c875.jpg";